module.exports = __webpack_public_path__ + "static/media/InterpersonalSkills3ff0238a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/categories/InterpersonalSkills.svg
// module id = 1302
// module chunks = 0